import { Row } from 'react-bootstrap'
import BreadCrumb from '../components/BreadCrumb/BreadCrumb'

const PageHeader = (props) => {
  return (
    <Row className="d-flex min-vh-25 justify-content-center align-items-center" data-aos="zoom-in" style={{height: "280px"}}>
        <div className="page-title w-25 d-flex flex-column align-items-center">
            <h1 className='display-6 text-uppercase'>{props.headerTitle}</h1>
            <BreadCrumb />
        </div>
    </Row>
  )
}

export default PageHeader